import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'
const TokenKey1 = 'Admin-Token1'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function getToken1() {
  return Cookies.get(TokenKey1)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function setToken1(token1) {
  return Cookies.set(TokenKey1, token1)
}

export function removeToken() {
  return Cookies.remove(TokenKey1)
}



// WEBPACK FOOTER //
// ./src/api/auth.js